import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const TriangleIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <g clipPath="url(#clip0_282_393210)">
        <path
          d="M8.26795 4C9.03775 2.66667 10.9623 2.66667 11.7321 4L17.3612 13.75C18.131 15.0833 17.1688 16.75 15.6292 16.75H4.37084C2.83124 16.75 1.86898 15.0833 2.63878 13.75L8.26795 4Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_282_393210">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
